import React, { useEffect, useState } from 'react';
import PageHeader from '@/components/PageHeader';
import AdminBillingNav from '@/components/adminBilling/AdminBillingNav';
import StatusChip from '@/components/adminBilling/StatusChip';
import { adminBillingService } from '@/api/services/adminBilling';
import { formatApiError } from '@/utils/formatApiError';
import { Navigate } from 'react-router-dom';
import { useMe } from '@/context/MeContext';

export default function AdminBillingProvidersPage() {
  const { me } = useMe();
  const [items, setItems] = useState<Record<string, unknown>[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    adminBillingService.providers().then((r) => setItems(r.items)).catch((e) => setError(formatApiError(e)));
  }, []);

  const isPlatform =
    me?.role === 'owner' || me?.role === 'platform_admin' || me?.role === 'admin';
  if (!isPlatform) return <Navigate to="/admin/billing" replace />;

  return (
    <div className="admin-billing-page">
      <AdminBillingNav />
      <PageHeader title="Payment providers" subtitle="Connection health and diagnostics (secrets masked)." />
      {error ? <div className="alert alert-error">{error}</div> : null}
      <div className="admin-billing-provider-grid">
        {items.map((p) => (
          <section key={String(p.provider)} className="panel admin-billing-provider-card">
            <h2>{String(p.displayName || p.provider)}</h2>
            <p>Status: <StatusChip status={String(p.status)} /></p>
            <p>Enabled: {p.enabled ? 'Yes' : 'No'}</p>
            <p>Connected: {p.connected ? 'Yes' : 'No'}</p>
            <p>Mode: {String(p.mode)}</p>
            <p>Webhook: {String(p.webhookStatus)}</p>
            <p>Secrets configured: {p.secretsConfigured ? 'Yes (masked)' : 'No'}</p>
            <p>Webhook failures: {String(p.webhookFailures)} / {String(p.webhookTotal)}</p>
            {p.lastError ? <p className="alert alert-warning">{String(p.lastError)}</p> : null}
            {p.lastTestedAt ? (
              <p className="muted">Last tested: {new Date(String(p.lastTestedAt)).toLocaleString()}</p>
            ) : null}
          </section>
        ))}
      </div>
    </div>
  );
}
